import React from 'react';

import { useSelector } from 'react-redux';

import StaticField from 'components/StaticField';
import { CUSTOMER_COMPANY_ADDRESS } from 'modules/Inquiry/Form/formFields';
import { getCustomerData } from 'store/inquiryDetails/selectors';
import { useTranslations } from 'utils/hooks/useTranslations';

const BusinessAddressStaticField = () => {
  const customerData = useSelector(getCustomerData);

  const t = useTranslations('pages.customerData.sections.businessDetails.fields.businessAddress');
  return <StaticField caption={t('caption')} text={customerData[CUSTOMER_COMPANY_ADDRESS]} />;
};

export default BusinessAddressStaticField;
